const locale = window.jsLocale || 'ja';

export default locale;



// WEBPACK FOOTER //
// ./es6/utils/locale.js